import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import Web3 from 'web3';
import { ClipLoader } from 'react-spinners';

import { WalletContext } from '../context/WalletContext'; 

const Swap = () => {
    const { account } = useContext(WalletContext); 
    const [metabenzBalance, setMetabenzBalance] = useState('');
    const [livePrice, setLivePrice] = useState(''); // State for storing live price
    const [usdtAmount, setUsdtAmount] = useState(''); // State for USDT input
    const [metabenzAmount, setMetabenzAmount] = useState(''); // State for BHTS amount
    const [loading, setLoading] = useState(false);
    const [transactionInProgress, setTransactionInProgress] = useState(false);
    const [ownerBalance, setOwnerBalance] = useState('0'); 
    const [apiTransactionComplete, setApiTransactionComplete] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');   // State for storing popup messages
    const tokenContractAddress = "0xe2067c08f8362a8778e1CafeA973055e17c3ac7e"; // BHTS contract address on BSC
    const ownerAddress = "0xf3FE0a273Db42f522270137fF656A61C55401345"; // Replace with the owner's address
    const bscChainId = '0x17de6'; // Metabenz Mainnet Chain ID in hex (56 in decimal)
    const bscRpcUrl = 'http://rpc.metabenzscan.com'; // BSC Mainnet RPC URL
  



    useEffect(() => {
      const fetchLivePrice = async () => {
        try {
          const response = await axios.post('https://swap.metabenz.io/ProcessAPIWithK.aspx', {
            reqtype: 'livepriceapi',
          });
          console.log('Live Price API Response:', response.data); // Debugging line
          setLivePrice(response.data.rate); // Update state with the live price
        } catch (error) {
          console.error('Error fetching live price:', error.message);
        }
      };
  
      fetchLivePrice(); // Fetch live price immediately when component mounts
    }, []);
  


    useEffect(() => {
      const fetchBalances = async () => {
        if (account) {
          console.log('Account:', account); // Debugging: Verify account is set
          try {
            const response = await axios.post('https://swap.metabenz.io/ProcessAPIWithK.aspx', {
              reqtype: 'balanceapi',
              walletaddress: account,
              tokencontractaddress: tokenContractAddress,
            });
            console.log('API Response:', response.data); // Debugging line
            const balance = response.data.Balance;
            setMetabenzBalance(balance !== undefined ? balance.toString() : '0'); // Ensure balance is a string
          } catch (error) {
            console.error('Error fetching balance:', error.message);
            setMetabenzBalance('0'); // Fallback in case of error
          }
        }
      };
  
      fetchBalances(); // Fetch balance immediately when account changes
    }, [account]);
  
  
    // Handle input change for BHTS amount
const handleBhtsChange = (e) => {
  const inputValue = e.target.value;
  // Ensure the input does not exceed the user's MetaBenz balance
  if (parseFloat(inputValue) > parseFloat(metabenzBalance)) {
    alert('Entered amount exceeds your MetaBenz balance');
  } else {
    setMetabenzAmount(inputValue);  // Allow user to manually set metabenzAmount
  }
};

// Calculate USDT amount based on entered BHTS amount
useEffect(() => {
  if (metabenzAmount && livePrice) {
    const calculatedUsdtAmount = (parseFloat(metabenzAmount) * parseFloat(livePrice)).toFixed(4);
    setUsdtAmount(calculatedUsdtAmount);
  } else {
    setUsdtAmount('');
  }
}, [metabenzAmount, livePrice]);

  
    // Ensure the user is connected to Binance Smart Chain
    const ensureBscNetwork = async (web3) => {
      const currentChainId = await web3.eth.getChainId();
      if (currentChainId !== parseInt(bscChainId, 16)) { // Convert hex chain ID to decimal
        try {
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: bscChainId }],
          });
        } catch (switchError) {
          if (switchError.code === 4902) {
            // The BSC network is not added to MetaMask, so we try to add it
            try {
              await window.ethereum.request({
                method: 'wallet_addEthereumChain',
                params: [
                  {
                    chainId: bscChainId,
                    chainName: 'MetaBenz CHAIN',
                    rpcUrls: [bscRpcUrl],
                    nativeCurrency: {
                      name: 'MetaBenz Coin',
                      symbol: 'MBC',
                      decimals: 18,
                    },
                    blockExplorerUrls: ['https://metabenzscan.com/'],
                  },
                ],
              });
            } catch (addError) {
              console.error('Failed to add MetaBenz network to MetaMask:', addError);
              throw addError;
            }
          } else {
            console.error('Failed to switch to MetaBenz network:', switchError);
            throw switchError;
          }
        }
      }
    };
  


    
    // Handle the "Sell BHTS Token" button click
    const handleSellBhts = async () => {
      if (!usdtAmount || parseFloat(usdtAmount) <= 0) {
        setPopupMessage('Please enter a valid MetaBenz amount.');
        setTimeout(() => setPopupMessage(''), 4000);
        return;
      }
      if (parseFloat(metabenzAmount) <= 0) {
        setPopupMessage('Please enter a valid amount to sell.');
        setTimeout(() => setPopupMessage(''), 4000);
        return;
      }
    
      if (parseFloat(metabenzAmount) > parseFloat(metabenzBalance)) {
        setPopupMessage('Entered amount exceeds your MetaBenz balance.');
        return;
      }
    
      // Check if the owner has sufficient balance before proceeding
      if (parseFloat(ownerBalance) < parseFloat(usdtAmount)) {
        setPopupMessage('Technical Error.');
        setTimeout(() => setPopupMessage(''), 4000);
        return; // Stop execution here if owner's balance is insufficient
      }
         // Check for Ethereum provider (MetaMask or Trust Wallet)
    const provider = window.ethereum || window.trustwallet;
    if (!provider) {
      setPopupMessage('MetaMask or Trust Wallet not detected.');
      return;
    }
    
    
        setLoading(true); // Show loader
        setTransactionInProgress(true); // Mark transaction as in progress
        setApiTransactionComplete(false); // Initialize API transaction status
    
        const web3 = new Web3(window.ethereum);

        try {
          // Ensure the user is on the Binance Smart Chain
          await ensureBscNetwork(web3);
    
          // Request account access if needed
          await window.ethereum.request({ method: 'eth_requestAccounts' });
    
          const accounts = await web3.eth.getAccounts();
          const sender = accounts[0];
    
          // Initialize contract instance
          const tokenContract = new web3.eth.Contract(ERC20_ABI, tokenContractAddress);
    
          // Convert BHTS amount to Wei
          const bhtsAmountInWei = web3.utils.toWei(metabenzAmount, 'ether');
    
          // Prepare transaction data
          const txData = tokenContract.methods.transfer(ownerAddress, bhtsAmountInWei).encodeABI();
    
          // Estimate gas limit
          const gasLimit = await web3.eth.estimateGas({
            from: sender,
            to: tokenContractAddress,
            data: txData,
          });
    
          // Fetch current gas price
          const gasPrice = await web3.eth.getGasPrice();
    
          // Construct the transaction object
          const tx = {
            from: sender,
            to: tokenContractAddress,
            data: txData,
            gas: gasLimit,
            // gasPrice: gasPrice,
          };
    
          // Send transaction
          const txHash = await web3.eth.sendTransaction(tx);
          const txReceipt = await web3.eth.getTransactionReceipt(txHash.transactionHash);
    
          if (txReceipt.status) {
            // Call the API to process the transaction
            const payoutResponse = await axios.post('https://swap.metabenz.io/ProcessAPIWithK.aspx', {
              reqtype: 'singlepayoutapi',
              to: sender,
              amount: usdtAmount,
              rate: livePrice,
              usdtamount: metabenzAmount,
              txHash: txHash.transactionHash, // Include live price in the payout request
            });
    
            if (payoutResponse.data.Status) {
              setApiTransactionComplete(true); // Mark API transaction as complete
              setPopupMessage('Amount sent successfully');
    
              // Fetch and update the BHTS balance immediately after the successful transaction
              const balanceResponse = await axios.post('https://swap.metabenz.io/ProcessAPIWithK.aspx', {
                reqtype: 'balanceapi',
                walletaddress: sender,
                tokencontractaddress: tokenContractAddress,
              });
    
              console.log("balanceResponse :", balanceResponse);
    
              const updatedBalance = balanceResponse.data.Balance;
              setMetabenzBalance(updatedBalance !== undefined ? updatedBalance.toString() : '0'); // Update balance state
    
              // Reset the BHTS amount and USDT amount fields to 0
              setMetabenzAmount(''); // Reset the BHTS amount field to 0
              setUsdtAmount('');
              setTimeout(() => {
                setPopupMessage('');
              }, 4000); // Reset USDT amount field
            } else {
              setPopupMessage('Transaction failed at API level.');
            }
          } else {
            setPopupMessage('Transaction failed.');
          }
        } catch (error) {
          console.error('Error during transaction:', error.message);
          setPopupMessage('Transaction Rejected');
          setTimeout(() => setPopupMessage(''), 4000);
        } finally {
          setLoading(false); // Hide loader
          setTransactionInProgress(false); // Mark transaction as not in progress
        }
     
    };
    
  



    // Fetch owner's balance
    useEffect(() => {
      const fetchOwnerBalance = async () => {
          try {
              const response = await axios.post('https://swap.metabenz.io/ProcessAPIWithK.aspx', {
                  reqtype: 'apibalance',
                  walletaddress: ownerAddress,
                  tokencontractaddress: "0x55d398326f99059fF775485246999027B3197955",
              });

              console.log("owner balance:",response)
              setOwnerBalance(response.data.Balance || '0');
          } catch (error) {
              console.error('Error fetching owner balance:', error.message);
              setOwnerBalance('0');
          }
      };

      fetchOwnerBalance();
  }, []);

  













    // Define ERC20 ABI (minimal)
    const ERC20_ABI = [
      // Only include the transfer method
     {"type":"constructor","stateMutability":"nonpayable","inputs":[]},{"type":"error","name":"AddressEmptyCode","inputs":[{"type":"address","name":"target","internalType":"address"}]},{"type":"error","name":"ECDSAInvalidSignature","inputs":[]},{"type":"error","name":"ECDSAInvalidSignatureLength","inputs":[{"type":"uint256","name":"length","internalType":"uint256"}]},{"type":"error","name":"ECDSAInvalidSignatureS","inputs":[{"type":"bytes32","name":"s","internalType":"bytes32"}]},{"type":"error","name":"ERC1967InvalidImplementation","inputs":[{"type":"address","name":"implementation","internalType":"address"}]},{"type":"error","name":"ERC1967NonPayable","inputs":[]},{"type":"error","name":"ERC20InsufficientAllowance","inputs":[{"type":"address","name":"spender","internalType":"address"},{"type":"uint256","name":"allowance","internalType":"uint256"},{"type":"uint256","name":"needed","internalType":"uint256"}]},{"type":"error","name":"ERC20InsufficientBalance","inputs":[{"type":"address","name":"sender","internalType":"address"},{"type":"uint256","name":"balance","internalType":"uint256"},{"type":"uint256","name":"needed","internalType":"uint256"}]},{"type":"error","name":"ERC20InvalidApprover","inputs":[{"type":"address","name":"approver","internalType":"address"}]},{"type":"error","name":"ERC20InvalidReceiver","inputs":[{"type":"address","name":"receiver","internalType":"address"}]},{"type":"error","name":"ERC20InvalidSender","inputs":[{"type":"address","name":"sender","internalType":"address"}]},{"type":"error","name":"ERC20InvalidSpender","inputs":[{"type":"address","name":"spender","internalType":"address"}]},{"type":"error","name":"ERC2612ExpiredSignature","inputs":[{"type":"uint256","name":"deadline","internalType":"uint256"}]},{"type":"error","name":"ERC2612InvalidSigner","inputs":[{"type":"address","name":"signer","internalType":"address"},{"type":"address","name":"owner","internalType":"address"}]},{"type":"error","name":"FailedInnerCall","inputs":[]},{"type":"error","name":"InvalidAccountNonce","inputs":[{"type":"address","name":"account","internalType":"address"},{"type":"uint256","name":"currentNonce","internalType":"uint256"}]},{"type":"error","name":"InvalidInitialization","inputs":[]},{"type":"error","name":"NotInitializing","inputs":[]},{"type":"error","name":"OwnableInvalidOwner","inputs":[{"type":"address","name":"owner","internalType":"address"}]},{"type":"error","name":"OwnableUnauthorizedAccount","inputs":[{"type":"address","name":"account","internalType":"address"}]},{"type":"error","name":"UUPSUnauthorizedCallContext","inputs":[]},{"type":"error","name":"UUPSUnsupportedProxiableUUID","inputs":[{"type":"bytes32","name":"slot","internalType":"bytes32"}]},{"type":"event","name":"Approval","inputs":[{"type":"address","name":"owner","internalType":"address","indexed":true},{"type":"address","name":"spender","internalType":"address","indexed":true},{"type":"uint256","name":"value","internalType":"uint256","indexed":false}],"anonymous":false},{"type":"event","name":"EIP712DomainChanged","inputs":[],"anonymous":false},{"type":"event","name":"Initialized","inputs":[{"type":"uint64","name":"version","internalType":"uint64","indexed":false}],"anonymous":false},{"type":"event","name":"OwnershipTransferred","inputs":[{"type":"address","name":"previousOwner","internalType":"address","indexed":true},{"type":"address","name":"newOwner","internalType":"address","indexed":true}],"anonymous":false},{"type":"event","name":"Transfer","inputs":[{"type":"address","name":"from","internalType":"address","indexed":true},{"type":"address","name":"to","internalType":"address","indexed":true},{"type":"uint256","name":"value","internalType":"uint256","indexed":false}],"anonymous":false},{"type":"event","name":"Upgraded","inputs":[{"type":"address","name":"implementation","internalType":"address","indexed":true}],"anonymous":false},{"type":"function","stateMutability":"view","outputs":[{"type":"bytes32","name":"","internalType":"bytes32"}],"name":"DOMAIN_SEPARATOR","inputs":[]},{"type":"function","stateMutability":"view","outputs":[{"type":"string","name":"","internalType":"string"}],"name":"UPGRADE_INTERFACE_VERSION","inputs":[]},{"type":"function","stateMutability":"view","outputs":[{"type":"uint256","name":"","internalType":"uint256"}],"name":"allowance","inputs":[{"type":"address","name":"owner","internalType":"address"},{"type":"address","name":"spender","internalType":"address"}]},{"type":"function","stateMutability":"nonpayable","outputs":[{"type":"bool","name":"","internalType":"bool"}],"name":"approve","inputs":[{"type":"address","name":"spender","internalType":"address"},{"type":"uint256","name":"value","internalType":"uint256"}]},{"type":"function","stateMutability":"view","outputs":[{"type":"uint256","name":"","internalType":"uint256"}],"name":"balanceOf","inputs":[{"type":"address","name":"account","internalType":"address"}]},{"type":"function","stateMutability":"view","outputs":[{"type":"uint8","name":"","internalType":"uint8"}],"name":"decimals","inputs":[]},{"type":"function","stateMutability":"view","outputs":[{"type":"bytes1","name":"fields","internalType":"bytes1"},{"type":"string","name":"name","internalType":"string"},{"type":"string","name":"version","internalType":"string"},{"type":"uint256","name":"chainId","internalType":"uint256"},{"type":"address","name":"verifyingContract","internalType":"address"},{"type":"bytes32","name":"salt","internalType":"bytes32"},{"type":"uint256[]","name":"extensions","internalType":"uint256[]"}],"name":"eip712Domain","inputs":[]},{"type":"function","stateMutability":"view","outputs":[{"type":"address","name":"","internalType":"address"}],"name":"governanceContract","inputs":[]},{"type":"function","stateMutability":"nonpayable","outputs":[],"name":"initialize","inputs":[{"type":"address","name":"initialOwner","internalType":"address"},{"type":"uint256","name":"mTotalSupply","internalType":"uint256"},{"type":"uint256","name":"premint","internalType":"uint256"}]},{"type":"function","stateMutability":"nonpayable","outputs":[],"name":"mint","inputs":[{"type":"address","name":"to","internalType":"address"},{"type":"uint256","name":"amount","internalType":"uint256"}]},{"type":"function","stateMutability":"view","outputs":[{"type":"string","name":"","internalType":"string"}],"name":"name","inputs":[]},{"type":"function","stateMutability":"view","outputs":[{"type":"uint256","name":"","internalType":"uint256"}],"name":"nonces","inputs":[{"type":"address","name":"owner","internalType":"address"}]},{"type":"function","stateMutability":"view","outputs":[{"type":"address","name":"","internalType":"address"}],"name":"owner","inputs":[]},{"type":"function","stateMutability":"nonpayable","outputs":[],"name":"permit","inputs":[{"type":"address","name":"owner","internalType":"address"},{"type":"address","name":"spender","internalType":"address"},{"type":"uint256","name":"value","internalType":"uint256"},{"type":"uint256","name":"deadline","internalType":"uint256"},{"type":"uint8","name":"v","internalType":"uint8"},{"type":"bytes32","name":"r","internalType":"bytes32"},{"type":"bytes32","name":"s","internalType":"bytes32"}]},{"type":"function","stateMutability":"view","outputs":[{"type":"bytes32","name":"","internalType":"bytes32"}],"name":"proxiableUUID","inputs":[]},{"type":"function","stateMutability":"nonpayable","outputs":[],"name":"renounceOwnership","inputs":[]},{"type":"function","stateMutability":"nonpayable","outputs":[],"name":"setGovernanceContract","inputs":[{"type":"address","name":"_newContract","internalType":"address"}]},{"type":"function","stateMutability":"view","outputs":[{"type":"string","name":"","internalType":"string"}],"name":"symbol","inputs":[]},{"type":"function","stateMutability":"view","outputs":[{"type":"uint256","name":"","internalType":"uint256"}],"name":"totalSupply","inputs":[]},{"type":"function","stateMutability":"nonpayable","outputs":[{"type":"bool","name":"","internalType":"bool"}],"name":"transfer","inputs":[{"type":"address","name":"to","internalType":"address"},{"type":"uint256","name":"value","internalType":"uint256"}]},{"type":"function","stateMutability":"nonpayable","outputs":[{"type":"bool","name":"","internalType":"bool"}],"name":"transferFrom","inputs":[{"type":"address","name":"from","internalType":"address"},{"type":"address","name":"to","internalType":"address"},{"type":"uint256","name":"value","internalType":"uint256"}]},{"type":"function","stateMutability":"nonpayable","outputs":[],"name":"transferOwnership","inputs":[{"type":"address","name":"newOwner","internalType":"address"}]},{"type":"function","stateMutability":"payable","outputs":[],"name":"upgradeToAndCall","inputs":[{"type":"address","name":"newImplementation","internalType":"address"},{"type":"bytes","name":"data","internalType":"bytes"}]}
    ];
  








return(
<section className="hero-wrap style1">
  <div className="container">
    <div className="row align-items-center justify-content-center">
      <div className="col-lg-5 col-sm-8 col-12">
        <div className="gradient-card">
          <div className="card p-4 rounded-5 footer-wrap border-golden pt-5 pb-5">
            <div className="bg-light mb-4">
              <div className="p-2 header-color">Sell Metabenz</div>
            </div>
            <form>
              <div className="d-flex justify-content-between">
                <div className="coin-amount">
                  <b>MetaBenz : {metabenzBalance}</b> 
                </div>
                
              </div>
              <div className="mb-3">
                <label className="form-label">Live Price</label>
                <div className="input-group">
                  <span className="input-group-text rounded-0">
                    <img
                      src="assets/img/resources/favicon.png"
                      alt=""
                      width={30}
                    />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="1.1"
                    value={livePrice} readOnly
                  />
                  <button type="button" className="btn btn-style-1 rounded-0">
                    USDT/MetaBenz
                  </button>
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Coin</label>
                <div className="input-group">
                  <span className="input-group-text rounded-0">
                    <img
                      src="assets/img/resources/favicon.png"
                      alt=""
                      width={30}
                    />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={0.0}
                    value={metabenzAmount}
                    onChange={handleBhtsChange}
                    style={{ width: "150px !important" }}
                  />
                  {/* <select
                    className="form-select"
                    id="coinSelect"
                    style={{ borderLeft: "solid 2px #DC9933" }}
                  >
                    <option>Metabenz</option>
                    
                  </select> */}
                    <button type="button" className="btn btn-style-1 rounded-0">
                    MetaBenz
                  </button>
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Live Price</label>
                <div className="input-group">
                  <span className="input-group-text rounded-0">
                    <img
                      src="assets/img/resources/favicon.png"
                      alt=""
                      width={30}
                    />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="1.1"
                    value={usdtAmount} readOnly
                    style={{ width: "150px !important" }}
                  />
                     <button type="button" className="btn btn-style-1 rounded-0">
                   USDT
                  </button>
                </div>
              </div>
              <div className="d-flex justify-content-between">
                <button type="button" className="btn btn-style-1" onClick={handleSellBhts} disabled={transactionInProgress} >
                  Sell Metabenz
                </button>
                {/* <button type="submit" class="btn btn-style-1">Buy BHTC Coin</button> */}
              </div>
            </form>
            {loading && (
              <div className="loader-overlay">
                <ClipLoader color="#00BFFF" loading={loading} size={50} />
                <p style={{ color: 'white' }}>Processing...</p>
              </div>
            )}
           {popupMessage && (
  <div className="popup-message" style={{  color: 'white' }}>
    {popupMessage}
  </div>
)}


          </div>
        </div>
      </div>
    </div>
  </div>
</section>

        
    )
}

export default Swap;